import type { ReactNode, HTMLAttributes } from 'react';
import styles from './Card.module.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'elevated' | 'outlined' | 'flat';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}

function Card({
  variant = 'elevated',
  padding = 'md',
  children,
  className,
  ...rest
}: CardProps) {
  const classes = [
    styles.card,
    styles[variant],
    styles[`pad-${padding}`],
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

/* ── Compound Components ── */

interface SectionProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function Header({ children, className, ...rest }: SectionProps) {
  return (
    <div className={`${styles.header} ${className ?? ''}`} {...rest}>
      {children}
    </div>
  );
}

function Body({ children, className, ...rest }: SectionProps) {
  return (
    <div className={`${styles.body} ${className ?? ''}`} {...rest}>
      {children}
    </div>
  );
}

function Footer({ children, className, ...rest }: SectionProps) {
  return (
    <div className={`${styles.footer} ${className ?? ''}`} {...rest}>
      {children}
    </div>
  );
}

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
